exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-bar-container {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative; }\n\n.progress-bar {\n  width: 100%;\n  height: 100%;\n  background-color: #36a2eb; }\n\n.progress-bar > strong {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  -ms-transform: translate(-50%, -50%) !important;\n      transform: translate(-50%, -50%) !important;\n  white-space: nowrap !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/progress-bar-cell/progress-bar-cell.component.scss
// module id = 1912
// module chunks = 66